module.exports = __webpack_public_path__ + "img/doc.eb9b433e.png";